(function () {
  // Wholesale form helper (tiny + non-blocking)
  var form = document.getElementById('WholesaleForm');
  if (!form) return;

  var statusEl = document.getElementById('wh-status');
  var hp = document.getElementById('wh_website');

  function speak(msg) {
    if (statusEl) statusEl.textContent = msg;
  }

  form.addEventListener('submit', function (e) {
    // Honeypot: if filled, block submission
    if (hp && hp.value && hp.value.trim() !== '') {
      e.preventDefault();
      speak('Submission blocked due to suspected spam.');
    } else {
      speak('Sending…');
    }
  }, { passive: false });
})();